import { render, staticRenderFns } from "./Lemon.vue?vue&type=template&id=84c0ed80&scoped=true&"
import script from "./Lemon.vue?vue&type=script&lang=js&"
export * from "./Lemon.vue?vue&type=script&lang=js&"
import style0 from "./Lemon.vue?vue&type=style&index=0&id=84c0ed80&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "84c0ed80",
  null
  
)

export default component.exports